export const serviceRequestPathFragment = {
  SERVICE_REQUEST: "SERVICE_REQUEST",
  /**
   * The description screen: the flow's entry, served by Rails at
   * `service_request/new` (`tasks_creation#new`). Every client route below hangs
   * off this path so a hard refresh lands on a URL Rails also answers.
   */
  SERVICE_REQUEST_CREATION: "SERVICE_REQUEST_CREATION",
  /**
   * Any screen of the creation flow.
   *
   * `screenKey` comes from the config, so it is a param rather than a fragment
   * per screen — a new subcategory config must not need a frontend deploy. The
   * key is validated against the fetched config on mount, and a screen the user
   * has not earned redirects to the first incomplete one.
   */
  SERVICE_REQUEST_CREATION_SCREEN: "SERVICE_REQUEST_CREATION_SCREEN",
  /**
   * The same flow, editing a request that already exists — served by Rails at
   * `service_request/:id/edit` (`tasks_creation#edit`) and rendering the very
   * same widget. Two fragments rather than one for the same reason as above:
   * the entry screen and every screen after it.
   */
  SERVICE_REQUEST_EDIT: "SERVICE_REQUEST_EDIT",
  SERVICE_REQUEST_EDIT_SCREEN: "SERVICE_REQUEST_EDIT_SCREEN",
} as const;

export const serviceRequestRoutes = {
  [serviceRequestPathFragment.SERVICE_REQUEST]: "service_requests/:id",
  [serviceRequestPathFragment.SERVICE_REQUEST_CREATION]: "service_request/new",
  [serviceRequestPathFragment.SERVICE_REQUEST_CREATION_SCREEN]:
    "service_request/new/:screenKey",
  [serviceRequestPathFragment.SERVICE_REQUEST_EDIT]:
    "service_request/:id/edit",
  [serviceRequestPathFragment.SERVICE_REQUEST_EDIT_SCREEN]:
    "service_request/:id/edit/:screenKey",
};
